
import React from "react";
import { Card } from "react-bootstrap";

export default function PrivacyPolicy() {
  return (
    <Card className="mb-3">
      <Card.Header>
        <h3 className="text-primary-label">Privacy Policy</h3>
      </Card.Header>
      <Card.Body>
        <p>
          At <strong>Lupie Community</strong>, we value your privacy and are committed to protecting your personal information.
        </p>
        <h5>Information We Collect</h5>
        <ul>
          <li>Basic profile details (name, email, phone) for account creation.</li>
          <li>Community and apartment details for service management.</li>
          <li>Usage data to improve app performance and user experience.</li>
        </ul>
        <h5>How We Use Your Information</h5>
        <ul>
          <li>To provide internal and external services for gated communities.</li>
          <li>To communicate updates, alerts, and community notices.</li>
          <li>To ensure security and compliance within your community.</li>
        </ul>
        <h5>Data Protection</h5>
        <p>
          We implement industry-standard security measures to protect your data. Your information will never be sold to third parties.
        </p>
        <h5>Contact Us</h5>
        <p>
          For any privacy-related queries, email us at: <a href="mailto:support@lupicommunity.com">support@lupiecommunity.com</a>
        </p>
      </Card.Body>
    </Card>
  );
}
